import React from 'react';
import bootLogo from './assets/boog-logo.png';

function Header() {
    return (
        <div>
            <div className="flex flex-row align-bottom">
                <img alt="Spring Boot Logo" src={bootLogo} className="h-20"/>
                <h1 className="text-5xl pt-1 font-sans text-gray-600"><span
                    className="text-gray-800">Spring Boot</span> Startup Analyzer</h1>
            </div>
            <div>
                <h2 className="ml-6">by <a className="text-purple-600" href="https://twitter.com/maciejwalkowiak">@maciejwalkowiak</a></h2>
            </div>
        </div>
    );
}

export default Header;
